import React from 'react';
import { FadeIn } from './FadeIn';
import { BuildingIcon, LandmarkIcon, Building2Icon, WalletIcon, PiggyBankIcon, StoreIcon, ShieldIcon, FlagIcon } from 'lucide-react';
export function TrustedBy() {
  const partners = [{
    name: 'FI First Design',
    icon: LandmarkIcon
  }, {
    name: 'Credit Unions',
    icon: BuildingIcon
  }, {
    name: 'Regional Banks',
    icon: Building2Icon
  }, {
    name: 'FinTechs',
    icon: WalletIcon
  }, {
    name: 'Commercial Banks',
    icon: PiggyBankIcon
  }, {
    name: 'Commerce',
    icon: StoreIcon
  }, {
    name: 'DoD',
    icon: ShieldIcon
  }, {
    name: 'Federal/State Government',
    icon: FlagIcon
  }];
  return <section className="py-12 border-b border-white/5 bg-navy" data-id="element-668" data-mp="37hunivry1z1o">
      <div className="max-w-7xl mx-auto px-6" data-id="element-669" data-mp="37icqeb943bik">
        <FadeIn data-id="element-670" data-mp="32jjcihpwxihv">
          <p className="text-center text-sm font-medium text-gray-500 uppercase tracking-widest mb-8" data-id="element-671" data-mp="32k2ws531ciz2">
            Trusted by forward-thinking institutions
          </p>
          <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-6 md:gap-x-12 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-672" data-mp="1poglqo34sraj">
            {partners.map((partner, index) => {
            const Icon = partner.icon;
            return <div key={index} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-300" data-id="element-673" data-mp="23g4z0up49lt3" data-mpi={index}>
                  <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-674" data-mp="28hapsmz7uyzz" />
                  <span className="text-lg font-semibold tracking-tight" data-id="element-675" data-mp="2dfm357opzrmy">
                    {partner.name}
                  </span>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </section>;
}